import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-credits-info-modal',
  templateUrl: './credits-info-modal.component.html',
  styleUrls: ['./credits-info-modal.component.scss']
})
export class CreditsInfoModalComponent {

  constructor(private modalCtrl: ModalController) {}

  async close() {
    await this.modalCtrl.dismiss();
  }
}
